import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHourglass: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHourglass"><Path d="M12 12L5.5 7.75V2.5H18.5V7.75L12 12ZM12 12L18.5 16.25V21.5H5.5V16.25L12 12ZM20.5 21.5H3.5M20.5 2.5H3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHourglass;
